// Func = limiting Scope for this file
(function(){
	
	function resizeWindow(){

	}
	function scrollDown(){
		let top = $(document).scrollTop();
		if (top > 0) {

		} else {

		}
	}

	// Book now functionality
	$('#booking-engine-trigger').click(function(){
		$('.booking-content').fadeToggle();
	});

	$('#booking-engine-trigger').click(function(){
		var $this = $(this);
		$this.toggleClass('on-change');
		if($this.hasClass('on-change')){
			$this.text('Close x');			
		} else {
			$this.text('Book Now');
		}
	});

	$(document).ready(function () {

		/* Transportation layout fix */
		transportationLayout();

		if(window.location.hash) {		
			$('html,body').scrollTop(0);
			setTimeout(function() {
			window.scrollTo(0, 0);
		  }, 1);
			var valScroll = $(window).scrollTop();
			$(window).on('load', function(){
				$('html,body').scrollTop(0);
				setTimeout(function(){
					var hash = window.location.hash;
				  var hashTop = $(hash).offset().top;
				  console.log(hashTop);
				  //$('html,body').scrollTop(hashTop-150)
				  $('html,body').animate({scrollTop:hashTop-150},1000);
				},300);
			})		  
		}

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			scrollDown();
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


		$('.book-now').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
		});
		//this class should be add to the header widget submit button
		$('.bookNow').on('click', function () {
			if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
		});

		//Check in and check out datepicker for booking engine
		$( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			altFormat: "yy-mm-dd",
        	altField: "#CheckIn-alt",
			changeMonth: true,
			numberOfMonths: 1,
			minDate: new Date(2019, 4 - 1, 1),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			altFormat: "yy-mm-dd",
        	altField: "#CheckOut-alt",
			changeMonth: true,
			minDate: new Date(2019, 4 - 1, 4),
			numberOfMonths: 1,
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		$('.js-open-content').click(function(){
			if($(this).siblings('.full-content').is(':hidden')){
				$(this).siblings('.full-content').slideDown();
				$(this).text('Read Less');
			}
			else {
				$(this).siblings('.full-content').slideUp();
				$(this).text('Read More');
			}
		})
	});

	$(window).on('load', function() {
		setTimeout(function(){
			$('.decoration-line-h, .decoration-line-h-bottom, .decoration-line').addClass('active');
		},1200);
		
		
	});

}());

function transportationLayout(){

	var dad = document.getElementById('item470488');
	if( dad!=null){
		var depic = dad.querySelector('.images.sym-slides');
		var textBox = dad.querySelector('.info');
		var depes = textBox.querySelectorAll('p');
		var depesLength = textBox.querySelectorAll('p').length
		var deDiv = '<div class="list_bottom-text"></div>';
	
		if( textBox.offsetHeight > depic.offsetHeight && depesLength > 2 ){
			dad.insertAdjacentHTML('beforeend', deDiv);
			var newDiv = dad.querySelector('.list_bottom-text');
			var i;
			for (i = 1; i < depes.length; i++) {
				newDiv.appendChild( depes[i] );
			}
		}
	}

}

$('.reviews__slider').on('init', function(event, slick, currentSlide, nextSlide){
	$('.reviews__slide').each(function(){
		$('.reviews__dots').append('<a href="javascript:;" class="reviews__dot"></a>')
	}).promise().done(function(){
		$('.reviews__dot').each(function(index){
            $(this).attr('aria-label',' Review dot ' + (index + 1));
        });

		$('.reviews__dot').on('click', function(){
			var indesxin = $(this).index();
			$('.reviews__dot').removeClass('active');
			var nein = indesxin + 1;
			$('.reviews__dot:nth-child(' + nein + ')').addClass('active');
			$('.reviews__slider').slick('slickGoTo',indesxin);
		});
		$('.reviews__dot').first().addClass('active');
	});
});

//Ada
$('.social-media .facebook ').attr('aria-label','Go to facebook ');
$('.social-media .twitter ').attr('aria-label','Go to twitter ');
$('.social-media .instagram ').attr('aria-label','Go to instagram ');